/**
 * usePlaybookDetail — selector hook for the playbook detail page.
 * Triggers fetchDetail on mount/playbookId change and exposes
 * detail / loading / error state plus a fetchWiki helper for the
 * lazy-load wiki tab.
 */

import { useEffect } from 'react';
import { usePlaybooksStore } from '@/stores/playbooks';

export function usePlaybookDetail(playbookId: string | undefined) {
  const detail = usePlaybooksStore((s) => s.detail);
  const loading = usePlaybooksStore((s) => s.detailLoading);
  const error = usePlaybooksStore((s) => s.detailError);
  const fetchDetail = usePlaybooksStore((s) => s.fetchDetail);
  const wiki = usePlaybooksStore((s) => s.wiki);
  const wikiLoading = usePlaybooksStore((s) => s.wikiLoading);
  const wikiError = usePlaybooksStore((s) => s.wikiError);
  const fetchWiki = usePlaybooksStore((s) => s.fetchWiki);
  const clearDetail = usePlaybooksStore((s) => s.clearDetail);

  useEffect(() => {
    if (!playbookId) return;
    fetchDetail(playbookId);
    return () => clearDetail();
  }, [playbookId, fetchDetail, clearDetail]);

  return {
    detail,
    loading,
    error,
    refresh: () => playbookId && fetchDetail(playbookId),
    wiki,
    wikiLoading,
    wikiError,
    fetchWiki: () => playbookId && fetchWiki(playbookId),
  };
}
